import React, { useState } from "react";

// Components
import Project from "components/Project/Project";

// Libraries & Packages
import { useParams } from "react-router-dom";
import Navigation from "utils/navigation/Navigation";

// Utils
import useContentfulData from "lib/Contentful/hooks/useContentfulData";

function ProjectPage() {
  // Params
  const { serviceID, projectID } = useParams();

  // State
  const [serviceType] = useState(Navigation.getNameByTitle(serviceID));
  const contentfulData = useContentfulData("service", projectID, {
    "fields.serviceType": serviceType,
    "fields.slug": `${serviceID}/${projectID}`,
  });

  return (
    <div>
      <Project projectData={contentfulData} />
    </div>
  );
}

export default ProjectPage;
